import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];
const LETTERS = "ANVOCRA".split("");

export const Intro = ({ onDone }) => {
  useEffect(() => {
    const id = setTimeout(onDone, 2300);
    return () => clearTimeout(id);
  }, [onDone]);
  return (
    <div data-testid="intro-overlay" className="fixed inset-0 z-[80] pointer-events-none">
      <motion.div className="absolute inset-y-0 left-0 w-1/2 bg-[var(--ink)]" initial={{ y: 0 }} animate={{ y: "-100%" }} transition={{ duration: 1.1, ease: EASE, delay: 1.5 }} />
      <motion.div className="absolute inset-y-0 right-0 w-1/2 bg-[var(--ivory)]" initial={{ y: 0 }} animate={{ y: "100%" }} transition={{ duration: 1.1, ease: EASE, delay: 1.5 }} />
      <motion.div className="absolute inset-0 flex items-center justify-center mix-blend-difference text-white" initial={{ opacity: 1 }} animate={{ opacity: 0 }} transition={{ duration: 0.4, delay: 1.4 }}>
        <div className="flex f-wordmark text-[13vw] md:text-[9vw] leading-none tracking-[0.08em]">
          {LETTERS.map((l, i) => (
            <span key={i} className="overflow-hidden inline-block">
              <motion.span className="inline-block" initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, ease: EASE, delay: 0.1 + i * 0.06 }}>
                {l}
              </motion.span>
            </span>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
